const zswl_fileList = {
    '0fb2396e0a522b29448595b487e876f2': '0fb2396e0a522b29448595b487e876f2',
    '5ba4813b3319ee679b1b614379854222': '5ba4813b3319ee679b1b614379854222',
    '00000000000000000000000000000001': '00000000000000000000000000000001', // 熊小聪
    '00000000000000000000000000000002': '00000000000000000000000000000002', // 熊小聪
    '00000000000000000000000000000003': '00000000000000000000000000000003', // 熊小聪
    '00000000000000000000000000000011': '00000000000000000000000000000011', // 熊博士
    '00000000000000000000000000000012': '00000000000000000000000000000012', // 熊博士
    '00000000000000000000000000000013': '00000000000000000000000000000013', // 熊博士
    '00000000000000000000000000000014': '00000000000000000000000000000014', // 熊博士
    '00000000000000000000000000000021': '00000000000000000000000000000021', // 熊小卓
    '00000000000000000000000000000022': '00000000000000000000000000000022', // 熊小卓
    '00000000000000000000000000000023': '00000000000000000000000000000023', // 熊小卓
    '00000000000000000000000000000031': '00000000000000000000000000000031', // 熊小淘
    '00000000000000000000000000000032': '00000000000000000000000000000032', // 熊小淘
    '00000000000000000000000000000033': '00000000000000000000000000000033', // 熊小淘
    '00000000000000000000000000000034': '00000000000000000000000000000034', // 熊小淘
    '00000000000000000000000000000035': '00000000000000000000000000000035', // 熊小淘
    '00000000000000000000000000000036': '00000000000000000000000000000036', // 小车
    
    
    'b0000000000000000000000000000001': 'b0000000000000000000000000000001', // 熊小镇
    'b0000000000000000000000000000002': 'b0000000000000000000000000000002', // 车站
    'b0000000000000000000000000000003': 'b0000000000000000000000000000003', // 农场
    'b0000000000000000000000000000004': 'b0000000000000000000000000000004', // 实验室
    'b0000000000000000000000000000005': 'b0000000000000000000000000000005', // 餐厅
    'b0000000000000000000000000000006': 'b0000000000000000000000000000006', // 餐厅内部
    'b0000000000000000000000000000007': 'b0000000000000000000000000000007', // 青青山
    'b0000000000000000000000000000008': 'b0000000000000000000000000000008', // 绿绿湖
    'b0000000000000000000000000000009': 'b0000000000000000000000000000009', // 
};
let zswl_fileArr = [];
for (var key in zswl_fileList) {
    zswl_fileArr.push(zswl_fileList[key]);
}
export default zswl_fileArr;